import React, { memo } from 'react';
import { IconCheck, IconCloseArrow } from '@app/icons';
import Container from '../Container';
import { cn } from 'lib/utils';

interface Props {
  title?: string;
  currentStep: number;
  maxCurrentStep: number;
  steps: { onClick: () => void; title: string }[];
  onClose?: () => void;
  fullWidth?: boolean;
}

function Stepper(props: Props) {
  const {
    title,
    steps,
    currentStep,
    maxCurrentStep,
    onClose,
    fullWidth = false,
  } = props;

  return (
    <div className="w-full">
      <div className="flex flex-col border-b border-border bg-background">
        <Container fullWidth={fullWidth}>
          <div className="flex items-center justify-between py-2">
            {!!title && (
              <span className="text-lg sm:text-xl font-semibold text-foreground flex items-center gap-2">
                {title}
              </span>
            )}
          </div>
          <div className="flex items-center justify-between gap-4 py-2">
            {steps.map((step, stepIndex) => {
              const isCompleted = stepIndex < currentStep;
              const isActive = stepIndex === currentStep;
              const isLocked = stepIndex > maxCurrentStep;

              return (
                <div
                  key={stepIndex}
                  className={cn(
                    'flex-1 flex flex-col items-center',
                    isLocked && 'opacity-50'
                  )}
                  onClick={
                    stepIndex <= maxCurrentStep ? step.onClick : undefined
                  }
                >
                  <div
                    className={cn(
                      'flex items-center justify-center w-8 h-8 rounded-full border text-sm font-medium transition',
                      isCompleted && 'bg-green-500 text-white border-green-500',
                      isActive &&
                        'ring-2 ring-primary border-primary text-primary',
                      !isCompleted &&
                        !isActive &&
                        'border-muted-foreground text-muted-foreground'
                    )}
                  >
                    {isCompleted ? (
                      <IconCheck className="w-4 h-4" />
                    ) : (
                      stepIndex + 1
                    )}
                  </div>
                  <span className="mt-1 text-xs sm:text-sm text-center">
                    {step.title}
                  </span>
                </div>
              );
            })}
          </div>
        </Container>
      </div>
    </div>
  );
}

export default memo(Stepper);
